export function Badge({ children, className = "" }) {
  return (
    <span
      className={`inline-block px-3 py-1 rounded-md bg-slateblue text-lightgray border border-silver hover:border-gold hover:shadow-gold transition-all duration-300 ease-in-out text-sm ${className}`}
    >
      {children}
    </span>
  );
}
